export interface AppConfig {
  apiBase: string;
  uploadTimeout: number;
  processingTimeout: number;
  maxFileSize: number;
  supportedFileTypes: string[];
  enableDragDrop: boolean;
  enableAdvancedOptions: boolean;
  enableDebugMode: boolean;
  defaultDetectReceiptFraudFormValues: {
    llmModelProvider: 'openrouter' | 'google';
    llmModelName: string;
    extractedData: object;
  };
  defaultDetectAbnormalLayoutFormValues: {
    llmModelProvider: 'openrouter' | 'google';
    llmModelName: string;
    merchantName: string;
  };
}

// Extend Window interface to include appConfig
declare global {
  interface Window {
    appConfig: AppConfig;
  }
}

// Fallback configuration in case window.appConfig is not loaded
const fallbackConfig: AppConfig = {
  apiBase: '',
  uploadTimeout: 300000, // 5 minutes
  processingTimeout: 600000, // 10 minutes
  maxFileSize: 52428800, // 50MB
  supportedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  enableDragDrop: true,
  enableAdvancedOptions: true,
  enableDebugMode: false,
  defaultDetectReceiptFraudFormValues: {
    llmModelProvider: 'google',
    llmModelName: 'gemini-3-flash-preview',
    extractedData: {},
  },
  defaultDetectAbnormalLayoutFormValues: {
    llmModelProvider: 'google',
    llmModelName: 'gemini-3-flash-preview',
    merchantName: '',
  },
};

// Load configuration from window.appConfig or use fallback
export const config: AppConfig = {
  ...fallbackConfig,
  ...(window.appConfig || {})
};

// Feature flags (derived from config)
export const features = {
  enableDragDrop: config.enableDragDrop,
  enableAdvancedOptions: config.enableAdvancedOptions,
  enableDebugMode: config.enableDebugMode,
};

// API endpoints
export const endpoints = {
  ping: '/ping',
  detectReceiptFraud: '/detect-receipt-fraud',
  detectAbnormalLayout: '/detect-abnormal-layout',
  getAbnormalLayoutMerchantSamples: '/get-abnormal-layout-merchant-samples',
};
